import { smoothScroll } from "../utils/smooth-scroll";

/**
 * Google Map
 * ======================================
 * - gmap api script required
 */

// todo - optimise & cleanup this component
if (typeof gMaplocations !== "undefined") {
	var locations = gMaplocations;
}

if (typeof gMapMarker !== "undefined") {
	var single = true;
}

var markerCluster;
var map;
var markers;
var mapOptions;

var activeInfoWindow;

function initMap() {
	/**
	 * Init
	 */
	mapOptions = {
		zoom: 8,
		center: { lat: 49.8175, lng: 15.473 },
		disableDefaultUI: true,
		zoomControl: true,
		scrollwheel: false
	};

	map = new google.maps.Map(document.getElementById("map"), mapOptions);

	/**
	 * Styled map
	 */
	var styledMapType = new google.maps.StyledMapType(gMapStyles);

	map.mapTypes.set("customMapStyle", styledMapType);
	map.setMapTypeId("customMapStyle");

	/**
	 * Markers
	 */
	if (typeof single === "undefined") {
		markers = Object.values(locations).map(function(location) {
			var marker = new google.maps.Marker({
				position: { lat: location.lat, lng: location.lng },
				meta: location,
				icon: assetsUrl + "images/gmap-marker.svg",
				title: "Zobrazit více",
				id: location.id
			});

			marker.addListener("click", function() {
				// map.setZoom(15);
				map.setCenter(marker.position);

				if (activeInfoWindow) {
					activeInfoWindow.close();
				}

				var promise = new Promise(function(resolve, reject) {
					setTimeout(function() {
						resolve(buildInfoWindow(marker));
					}, 100);
				});

				promise.then(function(value) {
					var infowindow = new google.maps.InfoWindow({
						content: value,
						pixelOffset: new google.maps.Size(0, -5),
						maxWidth: 375
					});

					infowindow.open(map, marker);
					activeInfoWindow = infowindow;
				});
			});

			return marker;
		});
	} else {
		var marker = new google.maps.Marker({
			position: { lat: gMapMarker.lat, lng: gMapMarker.lng },
			meta: gMapMarker,
			icon: assetsUrl + "images/gmap-marker.svg",
			title: "Zobrazit více",
			url: gMapMarkerUrl ? gMapMarkerUrl : false
		});

		if (gMapMarkerUrl) {
			google.maps.event.addListener(marker, "click", function() {
				// window.location.href = this.url;

				smoothScroll(this.url, 300);
				return false;
			});
		}

		marker.setMap(map);

		map.setZoom(12);
		map.setCenter(marker.position);
	}

	/**
	 * Infowindow
	 */
	function buildInfoWindow(marker) {
		var template = document.getElementById("infowindow");
		var el = parseHTML(template.innerHTML);

		// fields
		var img = el.getElementById("infowindow-img");
		var imgLink = el.getElementById("infowindow-img-link");
		var rating = el.getElementById("infowindow-rating");
		var title = el.getElementById("infowindow-title");
		var button = el.getElementById("infowindow-button");
		var address = el.getElementById("infowindow-address");
		var hours = el.getElementById("infowindow-hours");
		var phone = el.getElementById("infowindow-phone");
		var email = el.getElementById("infowindow-email");

		img.removeAttribute("id");
		title.removeAttribute("id");
		button.removeAttribute("id");
		address.removeAttribute("id");
		phone.removeAttribute("id");
		email.removeAttribute("id");

		if (rating) {
			rating.removeAttribute("id");
			rating.innerHTML = marker.meta.rating;
		}

		if (hours) {
			hours.removeAttribute("id");
			hours.innerHTML = marker.meta.opening_hours;

			if (!marker.meta.opening_hours) {
				hours.remove();
			}
		}

		if (marker.meta.logo) {
			img.src = marker.meta.logo;
		} else {
			img.parentNode.innerHTML = "";

			title.closest(".infowindow").classList.add("infowindow--nophoto");
		}

		title.innerHTML = marker.meta.title;
		address.innerHTML = marker.meta.address;

		if (marker.meta.phone) {
			phone.innerHTML = marker.meta.phone;
			phone.href = "tel:" + marker.meta.phone;
		} else {
			phone.parentNode.innerHTML = "";
		}

		if (marker.meta.email) {
			email.innerHTML = marker.meta.email;
			email.href = "mailto:" + marker.meta.email;
		} else {
			email.parentNode.innerHTML = "";
		}

		if (marker.meta.link) {
			imgLink.href = marker.meta.link;
			button.href = marker.meta.link;

			if (marker.meta.link_external) {
				imgLink.setAttribute("target", "_blank");
				imgLink.setAttribute("rel", "noopener");

				button.setAttribute("target", "_blank");
				button.setAttribute("rel", "noopener");
			}
		} else {
			button.remove();
			imgLink.remove();
			// button.addEventListener("click", function(e) {
			//     smoothScroll("map-button-anchor");

			//     e.preventDefault();
			//   });
		}

		return el;
	}

	/**
	 * Cluster
	 */
	if (typeof single === "undefined") {
		initMarkerCluster(markers);
	}

	/**
	 * Links to markers
	 */
	var markerLinks = document.getElementsByClassName("js-gmap-link");
	Array.from(markerLinks).forEach(function(element) {
		element.addEventListener("click", function(e) {
			triggerMarker(element.getAttribute("data-marker"));

			e.preventDefault();
		});
	});
}

function parseHTML(html) {
	var t = document.createElement("template");
	t.innerHTML = html;

	return t.content.cloneNode(true);
}

/**
 * MarkerCluster
 */

function initMarkerCluster(markers) {
	var clusterStyles = [
		{
			textColor: "#C8E2BB",
			textSize: 12,
			backgroundPosition: "0, 0",
			url: assetsUrl + "images/gmap-cluster.svg",
			height: 54,
			width: 54
		}
	];

	var mcOptions = {
		gridSize: 50,
		styles: clusterStyles,
		maxZoom: 15,
		ignoreHidden: true
	};

	markerCluster = new MarkerClusterer(map, markers, mcOptions);
}

/**
 * Filter
 */
function initMapFilter() {
	var form = document.getElementById("js-gmap-form");

	form.addEventListener("submit", function(e) {
		submitMapFilter();

		e.preventDefault();
	});
}

function submitMapFilter() {
	var formData = getMapFormValues();
	var bounds = new google.maps.LatLngBounds();
	var visiblemarker = false;
	var visibleMarkers = [];

	if (activeInfoWindow) {
		activeInfoWindow.close();
	}

	Object.keys(locations).map(function(i) {
		var markerData = locations[i];
		var id = locations[i]["id"];

		var options = {
			keys: ["id"],
			threshold: 0
		};
		var fuse = new Fuse(markers, options);
		var result = fuse.search(id.toString());

		if (result.length) {
			var marker = result[0];

			if (isMarkerVisible(markerData, formData)) {
				visiblemarker = true;
				visibleMarkers.push(marker);
				marker.setVisible(true);
				bounds.extend(marker.getPosition());
			} else {
				marker.setVisible(false);
			}
		}
	});

	markerCluster.repaint();

	if (visiblemarker) {
		map.setCenter(bounds.getCenter());
		map.fitBounds(bounds);

		if (
			formData.search == "" &&
			formData.region == "" &&
			typeof formData.attr == "undefined"
		) {
			hideMapResults();
		} else {
			showMapResults(visibleMarkers);
		}
	} else {
		alert("Pro zadanou kombinaci nebylo nic nenalezeno.");

		hideMapResults();

		map.setCenter(mapOptions.center);
		map.setZoom(mapOptions.zoom);
	}
}

function showMapResults(markers) {
	buildFilterChips();
	buildFilterResults(markers);

	document.getElementById("gmap-results").removeAttribute("hidden");
	document.getElementById("gmap-top").setAttribute("hidden", "hidden");
}

function hideMapResults() {
	document.getElementById("gmap-results").setAttribute("hidden", "hidden");
	document.getElementById("gmap-top").removeAttribute("hidden");
}

function buildFilterChip(type, name, id = 0) {
	return (
		'<button class="chip" data-type="' +
		type +
		'" data-id="' +
		id +
		'">' +
		name +
		'<div class="chip__control">×</div></button>'
	);
}

function buildFilterChips() {
	var chipsEl = document.getElementById("gmap-chips");
	var formdata = getMapFormValues();
	var chips = [];

	var search = formdata.search;
	var attrs = formdata.attr;
	var region = formdata.region;

	chipsEl.innerHTML = "";

	if (search.length > 0) {
		chips.push(buildFilterChip("search", search));
	}

	if (typeof attrs == "string") {
		var attrs = [];
		attrs.push(formdata.attr);
	}

	if (typeof attrs == "undefined") {
		var attrs = [];
	}

	if (attrs.length > 0) {
		Array.from(attrs).forEach(function(attr) {
			var name = document.querySelector(
				'#gmap-select-attr option[value="' + attr + '"]'
			);

			chips.push(buildFilterChip("attr", name.innerHTML, attr));
		});
	}

	if (region != "") {
		var name = document.querySelector(
			'#gmap-select-region option[value="' + region + '"]'
		);

		chips.push(buildFilterChip("region", name.innerHTML, region));
	}

	Array.from(chips).forEach(function(element) {
		var el = parseHTML(element);

		chipsEl.appendChild(el);

		chipsEl.lastChild.addEventListener("click", function(e) {
			removeChipsItem(this);
		});
	});
}

function removeChipsItem(item) {
	var type = item.getAttribute("data-type");
	var id = item.getAttribute("data-id");

	if (type == "search") {
		document.getElementById("gmap-search").value = "";
	} else if (type == "attr") {
		var option = document.querySelector(
			'#gmap-select-attr option[value="' + id + '"]'
		);
		option.selected = false;

		$("#gmap-select-attr").trigger("change.select2");
	} else if (type == "region") {
		document.getElementById("gmap-select-region").value = "";
		$("#gmap-select-region").trigger("change.select2");
	}

	submitMapFilter();
}

function buildFilterResults(markers) {
	var resultsEl = document.getElementById("gmap-results-list");
	var template = document.getElementById("results-item");

	resultsEl.innerHTML = "";

	Array.from(markers).forEach(function(marker) {
		var el = parseHTML(template.innerHTML);
		var img = el.getElementById("result-img");
		var rating = el.getElementById("result-rating");
		var title = el.getElementById("result-title");
		var address = el.getElementById("result-address");
		var hours = el.getElementById("result-hours");
		var phone = el.getElementById("result-phone");
		var email = el.getElementById("result-email");
		var link = el.getElementById("result-link");

		if (marker.meta.logo) {
			img.src = marker.meta.logo;
		} else {
			img.remove();

			title.closest(".advisor-card").classList.add("advisor-card--nophoto");
		}

		if (rating) {
			rating.innerHTML = marker.meta.rating;
		}

		title.removeAttribute("id");
		title.innerHTML = marker.meta.title;

		if (address) {
			address.removeAttribute("id");
			address.innerHTML = marker.meta.address;
			address.addEventListener("click", function(e) {
				google.maps.event.trigger(marker, "click");
				smoothScroll("map-anchor");

				e.preventDefault();
			});
		}

		if (hours) {
			hours.removeAttribute("id");
			hours.innerHTML = marker.meta.opening_hours;
		}

		if (marker.meta.phone) {
			phone.childNodes[2].innerHTML = marker.meta.phone;
			phone.href = "tel:" + marker.meta.phone;
		} else {
			phone.remove();
		}

		if (marker.meta.email) {
			email.childNodes[2].innerHTML = marker.meta.email;
			email.href = "mailto:" + marker.meta.email;
		} else {
			email.remove();
		}

		if (marker.meta.link) {
			if (link.childNodes[2]) {
				link.childNodes[2].innerHTML = marker.meta.link;
			}
			link.href = marker.meta.link;
		} else {
			link.remove();
		}

		resultsEl.appendChild(el);
	});
}

function resetMapFilter(submit = true) {
	var form = document.getElementById("js-gmap-form");

	form.reset();

	$(".js-select2").trigger("change.select2");
	$(".js-select2-check").trigger("change.select2");

	if (submit) {
		submitMapFilter();
	}
}

function isMarkerVisible(marker, filter) {
	var fuseMarker = [];
	fuseMarker.push(marker);

	var search = filter.search.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	var attrs = filter.attr;
	var region = filter.region;

	// search
	if (search.length > 0) {
		var options = {
			keys: ["search"],
			threshold: 0.1
		};
		var fuse = new Fuse(fuseMarker, options);
		var result = fuse.search(search);

		if (result.length === 0) {
			return false;
		}
	}

	// attrs
	if (typeof attrs == "string") {
		var attrs = [];
		attrs.push(filter.attr);
	}

	if (typeof attrs == "undefined") {
		var attrs = [];
	}

	if (attrs.length > 0) {
		var options = {
			keys: ["attrs"],
			threshold: 0.1
		};
		var fuse = new Fuse(fuseMarker, options);

		for (let i = 0; i < attrs.length; i++) {
			var attr = attrs[i];
			var result = fuse.search(attr);

			if (result.length === 0) {
				return false;
			}
		}
	}

	// region
	if (region != "") {
		var options = {
			keys: ["regions"],
			threshold: 0.1
		};
		var fuse = new Fuse(fuseMarker, options);
		var result = fuse.search(region);

		if (result.length === 0) {
			return false;
		}
	}

	return true;
}

function getMapFormValues() {
	var formData = new FormData(document.getElementById("js-gmap-form"));

	var object = {};
	formData.forEach((value, key) => {
		if (!object.hasOwnProperty(key)) {
			object[key] = value;
			return;
		}
		if (!Array.isArray(object[key])) {
			object[key] = [object[key]];
		}
		object[key].push(value);
	});

	return object;
}

/**
 * Extra
 */
function triggerMarker(id) {
	resetMapFilter(false);

	var search = id.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

	$("#gmap-search").val(search);

	submitMapFilter();
}

if (document.getElementById("map")) {
	initMap();

	if (typeof single === "undefined") {
		initMapFilter();
	}
}
